import React from "react";
import Customers from "../components/customers/Customers";
import TitleUpdater from "../components/common/layout/TitleUpdater";

export default function CustomersPage() {

  return (
    <div>
      <TitleUpdater />
      <Customers />
    </div>
  );
}
